import { useState, useEffect } from 'react';
import { api } from '@/api/client';
import { toast } from '@/components';

interface Update {
  id: string;
  template_type: string;
  name: string;
  master_version: number;
  synced_version: number;
}

export function TemplateUpdateBanner() {
  const [updates, setUpdates] = useState<Update[]>([]);

  useEffect(() => {
    api<{ updates: Update[] }>('/tenant/templates/update-check')
      .then(data => setUpdates(data.updates || []))
      .catch(() => {});
  }, []);

  if (!updates.length) return null;

  const handleApply = async (id: string) => {
    try {
      await api(`/tenant/templates/${id}/apply-update`, { method: 'POST' });
      toast('テンプレートを更新しました', 'success');
      setUpdates(prev => prev.filter(u => u.id !== id));
    } catch { toast('更新に失敗しました', 'error'); }
  };

  const handleApplyAll = async () => {
    for (const u of updates) {
      try {
        await api(`/tenant/templates/${u.id}/apply-update`, { method: 'POST' });
      } catch { /* continue */ }
    }
    setUpdates([]);
    toast('全テンプレートを更新しました', 'success');
  };

  return (
    <div style={{
      background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: '8px',
      padding: '12px 16px', marginBottom: '16px', display: 'flex',
      alignItems: 'center', justifyContent: 'space-between', fontSize: '13px',
    }}>
      <span style={{ color: '#b45c08' }}>
        契約テンプレートの更新があります（{updates.length}件）
      </span>
      <button onClick={handleApplyAll} style={{
        background: '#f59e0b', color: '#fff', border: 'none', borderRadius: '6px',
        padding: '6px 14px', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
      }}>一括更新</button>
    </div>
  );
}
